import _ from 'lodash';
import {checkIfDefinedNonNullAndNotEmptyString} from 'common/utils';

export const validateForExpiredSuspendedSamGov = (samgov) => {
  if (samgov !== undefined) {
    if (samgov.hasKnownExclusion === 'Yes') {
      return true;
    }
  }

  return false;
};

export const validateForStatutoryRequirements = (statuatoryValidationList) => {
  // Show panel section if any of the statuatory rules have been violated
  var cleanList = _.filter(statuatoryValidationList, _.size);
  if (cleanList && cleanList.length == 0) {
    return true;
  }

  return false;
};

export const validateRequiredGrantType = (fundingStreams, grantType) => {
  return !!_.find(
    fundingStreams,
    (fundingStream) => fundingStream.fundingStreamType === grantType
  );
};

export const doesNotExist = (value) => {
  return !checkIfDefinedNonNullAndNotEmptyString(value) || value === false;
};

export default {
  expiredSamGov: validateForExpiredSuspendedSamGov,
  statutoryRequirements: validateForStatutoryRequirements,
  requiredGrantType: validateRequiredGrantType,
  hideIfExists: doesNotExist,
};
